"use client";
import { useEffect, useState } from 'react';
import { FiCheckCircle, FiXCircle, FiAlertCircle, FiInfo, FiX } from 'react-icons/fi';

const toastConfig = {
  success: {
    icon: FiCheckCircle,
    bgColor: 'bg-success-soft',
    borderColor: 'border-success',
    iconColor: 'text-success',
    textColor: 'text-success'
  },
  error: {
    icon: FiXCircle,
    bgColor: 'bg-danger-soft',
    borderColor: 'border-danger',
    iconColor: 'text-danger',
    textColor: 'text-danger'
  },
  warning: {
    icon: FiAlertCircle,
    bgColor: 'bg-warning-soft',
    borderColor: 'border-warning',
    iconColor: 'text-warning',
    textColor: 'text-warning'
  },
  info: {
    icon: FiInfo,
    bgColor: 'bg-info-soft',
    borderColor: 'border-info',
    iconColor: 'text-info',
    textColor: 'text-info'
  }
};

export default function Toast({ toast, onClose }) {
  const [isExiting, setIsExiting] = useState(false);
  const config = toastConfig[toast.type] || toastConfig.info;
  const Icon = config.icon;

  useEffect(() => {
    if (toast.duration > 0) {
      const exitTimer = setTimeout(() => {
        setIsExiting(true);
      }, toast.duration - 300);

      return () => clearTimeout(exitTimer);
    }
  }, [toast.duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => onClose(toast.id), 300);
  };

  return (
    <div
      className={`
        flex items-start gap-3 min-w-[320px] max-w-md p-4 mb-3 rounded-xl shadow-lg
        ${config.bgColor} border-l-4 ${config.borderColor}
        transform transition-all duration-300 ease-out
        ${isExiting 
          ? 'translate-x-[120%] opacity-0' 
          : 'translate-x-0 opacity-100 animate-slideIn'
        }
      `}
      role="alert"
    >
      <Icon className={`${config.iconColor} flex-shrink-0 mt-0.5`} size={20} />
      
      <p className={`flex-1 text-sm font-medium ${config.textColor} leading-relaxed`}>
        {toast.message}
      </p>

      <button
        onClick={handleClose}
        className={`${config.iconColor} hover:opacity-70 transition-opacity flex-shrink-0`}
        aria-label="Close notification"
      >
        <FiX size={18} />
      </button>
    </div>
  );
}
